var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { toggleMark } from "prosemirror-commands";
import markInputRule from "../lib/markInputRule";
import Mark from "./Mark";
var Highlight = /** @class */ (function (_super) {
    __extends(Highlight, _super);
    function Highlight() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Highlight.prototype, "name", {
        get: function () {
            return "mark";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Highlight.prototype, "schema", {
        get: function () {
            return {
                parseDOM: [{ tag: "mark" }],
                toDOM: function () { return ["mark"]; },
            };
        },
        enumerable: true,
        configurable: true
    });
    Highlight.prototype.inputRules = function (_a) {
        var type = _a.type;
        return [markInputRule(/(?:==)([^=]+)(?:==)$/, type)];
    };
    Highlight.prototype.keys = function (_a) {
        var type = _a.type;
        return {
            "Mod-Ctrl-h": toggleMark(type),
        };
    };
    Object.defineProperty(Highlight.prototype, "toMarkdown", {
        get: function () {
            return {
                open: "==",
                close: "==",
                mixable: true,
                expelEnclosingWhitespace: true,
            };
        },
        enumerable: true,
        configurable: true
    });
    Highlight.prototype.parseMarkdown = function () {
        return { mark: "mark" };
    };
    return Highlight;
}(Mark));
export default Highlight;
